import { Button, Link } from '@gyym/ui'
import { Search } from '@gyym/ui/icons'
import React from 'react'

import { Container } from './styles'

export interface TopButtonProps {
  href: string
  mt?: number
  children: React.ReactNode
}

export const TopButton = ({ mt, href, children }: TopButtonProps) => {
  return (
    <Container mt={mt}>
      <Button size="lg" variant="brand" rounded={true} asChild>
        <Link href={href}>
          <Search /> {children}
        </Link>
      </Button>
    </Container>
  )
}
